import {UnrealUIContextProps} from './componentContext';

export const twinmotionDefaultUIContext: UnrealUIContextProps = {
    RouteComponent: 'a',
    router: {
        push: () => {
            console.log('twinmotionDefaultUIContext.router() push');
        }
    },
    imageHero: {
        spacing: 'thin'
    },
    outlinedCard: {
        arrows: 'arrow-right-alt',
        noBorder: true
    },
    quoteIcon: {
        icon: 'rounded'
    },
    carousel: {
        icon: 'alt'
    },
    staticIndustry: 'architecture'
};
